export const tryParseJSONObject = (
  str: string,
): { key: string, data?: Record<string, string> } => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return { key: str };
  }
};
